import { useParams } from "react-router-dom";
import { dotIcon, dragAndDrop } from "../../asset";
import CustomInput from "../../components/CustomInput";
import PageHeader from "../../components/PageHeader";
import { useEffect, useState } from "react";
import { TicketDetails } from "../../types/helpDeskType";
import helpDeskApis from "../../api/helpDeskApis";
import DocumentUpload from "../../components/common/DocumetUpload";
import { formatDateTime } from "../../util/functions/UniversalFunctions";

export default function ViewTicketDetails() {
  const [ticket, setTicket] = useState<TicketDetails | null>(null);
  const [loading, setLoading] = useState(false);

  const { ticketId } = useParams();

  const handleChange = () => {};

  useEffect(() => {
    if (!ticketId) return;

    const fetchTicket = async () => {
      setLoading(true);
      try {
        const res = await helpDeskApis.fetchTicketsyId(Number(ticketId));

        if (res?.status === 1) {
          setTicket(res.data);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTicket();
  }, [ticketId]);

  return (
    <div className="flex flex-col gap-5">
      <PageHeader showBack />
      <div className="flex flex-col lg:flex-row gap-2">
        <div className="grid gap-8 w-full bg-white p-4 lg:p-7 rounded-lg">
          <div className="flex flex-col lg:flex-row gap-7">
            <CustomInput
              name=""
              label="Ticket number"
              value={ticket?.ticketId.toString() || ""}
              onChange={handleChange}
              className="lg:w-[80%]"
            />
            <CustomInput
              name=""
              type="date"
              label="Ticket date"
              value={ticket?.createdAt.split("T")[0] || ""}
              onChange={handleChange}
            />
          </div>
          <CustomInput
            name=""
            label="Ticket title"
            value={ticket?.ticketTitle || ""}
            onChange={handleChange}
            placeholder="Enter the ticket title"
          />
          <CustomInput
            name=""
            value={ticket?.ticketDescription || ""}
            placeholder="Enter the ticket description..."
            isTextarea
            rows={3}
            label="Ticket description"
            onChange={handleChange}
          />
          <DocumentUpload
            value={ticket?.attachedFileUrl || ""}
            onUploadComplete={handleChange}
            label="Attach files"
            text={true}
            placeholderImage={dragAndDrop}
            showButton={false}
            className="h-[170px]"
          />
          {/* <div className="flex justify-end items-end mt-5">
            <CustomButton color="bg-primary-500" text="Create Ticket" />
          </div> */}
        </div>

        <div className="bg-white p-7 text-neutral-400 flex flex-col gap-4 rounded-lg max-w-96 w-full">
          <h3 className="text-xl font-semibold">Ticket Timeline</h3>

          {ticket?.helpDeskTimelines?.length ? (
            ticket.helpDeskTimelines.map((timeline, index) => (
              <div key={timeline.id} className="flex gap-x-3 items-start">
                
                <div className="flex flex-col items-center mt-1 shrink-0">
                  <img src={dotIcon} alt="dot" className="w-4 h-4 z-10" />
                  {index !== ticket.helpDeskTimelines.length - 1 && (
                    <div className="w-px h-20 bg-neutral-50"></div>
                  )}
                </div>
                <div className="flex flex-col gap-2">
                  <span className="text-sm font-medium">
                    {timeline.actionTitle}
                  </span>

                  <label className="text-sm font-medium">
                    By:{" "}
                    <span className="text-primary-500">
                      {timeline.actionBy || "---"}
                    </span>
                  </label>

                  <label className="text-sm font-medium">
                    At:{" "}
                    <span className="text-success-600">
                      {formatDateTime(timeline.actionTime)}
                    </span>
                  </label>

                </div>
              </div>
            ))
          ) : (
            <p className="text-sm text-neutral-400">No timeline available</p>
          )}
        </div>
      </div>
    </div>
  );
}
